import { Link } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowRight01Icon } from '@hugeicons/core-free-icons';

function BreadCrump({ path, main, sub }) {
    return (
        <div className='inline-flex min-h-[38px] w-max items-center gap-1 overflow-hidden border border-gray-100 dark:border-gray-700 rounded-lg px-2 mb-2 text-sm bg-white dark:bg-gray-800 shadow-sm'>
            {main &&
                <Link to={path} className='text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 px-2 py-1 rounded-md transition-colors'>
                    {main}
                </Link>
            }
            {main &&
                <HugeiconsIcon icon={ArrowRight01Icon} size={12} className="text-gray-300 dark:text-gray-600 shrink-0" />
            }
            <span className="font-medium text-gray-700 dark:text-gray-200 px-2 py-1 hidden sm:block">
                {sub ? sub : ""}
            </span>
        </div>
    )
}

export default BreadCrump